import { Component, Inject } from '@angular/core';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {  
    constructor() {
    }
}
